import { useEffect, useState } from "react";

function AnimatedCounter({ value, loading }) {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    let interval;
    if (loading) {
      interval = setInterval(() => {
        // random number between 0 and 99 (you can adjust range)
        setDisplayValue(Math.floor(Math.random() * 12));
      }, 100); // change number every 100ms
    } else {
      setDisplayValue(value); // set to real value when loading ends
    }

    return () => clearInterval(interval);
  }, [loading, value]);

  return <span>{displayValue}</span>;
}

export default AnimatedCounter;
